/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const RestoreRequest = zod
	.object({
		version_id: zod.uuid().describe('Version ID to restore')
	})
	.describe('Request body for restoring a praetor version');

export type RestoreRequest = zod.input<typeof RestoreRequest>;
export type RestoreRequestOutput = zod.output<typeof RestoreRequest>;
